import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: var(--space-4);
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: var(--space-1);
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 10px;
  top: 36px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: var(--radius-sm);
  color: var(--color-text-tertiary);
  display: flex;
  align-items: center;
  transition: color var(--duration-fast) var(--ease-standard),
    background var(--duration-fast) var(--ease-standard);

  &:hover {
    color: var(--color-text);
    background: var(--color-surface-subtle);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

export const FormHeader = styled.div`
  margin-bottom: var(--space-2);
`;

export const FormTitle = styled.h2`
  margin: 0 0 4px 0;
  font-family: var(--font-display);
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  letter-spacing: -0.01em;
  color: var(--color-text);
`;

export const FormSubtitle = styled.p`
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-family: var(--font-sans);
  font-size: var(--font-size-xs);
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: var(--font-weight-semibold);

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: var(--color-border);
  }
`;

export const StepBar = styled.div`
  display: flex;
  gap: 4px;
`;

export const StepSegment = styled.div`
  flex: 1;
  height: 3px;
  border-radius: var(--radius-pill);
  background: ${({ active }) =>
    active ? "var(--color-accent)" : "var(--color-border)"};
  transition: background var(--duration-base) var(--ease-standard);
`;

export const SectionNav = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--space-1);
`;

export const BackIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  margin-left: -6px;
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  border-radius: 50%;
  transition: background var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);

  &:hover {
    background: var(--color-surface-subtle);
    color: var(--color-text);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

export const GoogleButton = styled.button`
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  cursor: pointer;
  transition: background var(--duration-fast) var(--ease-standard),
    border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);

  &:hover {
    background: var(--color-surface-subtle);
    border-color: var(--color-border-strong);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
